import React, { Component } from 'react'
import {
  AUTH_API_URL,
  FB_API_URL,
  EVRAZ_PRODUCTS_CALC,
  parseJwt
} from '../lib/env'
import axios from 'axios'
import {
  Paper,
  IconButton,
  Button,
  TextField,
  TableHead,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination,
  Snackbar
} from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import ClearIcon from '@material-ui/icons/Clear'
import moment from 'moment'
import TablePaginationActions from '../components/table_pagination_actions'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import SearchIcon from '@material-ui/icons/Search'
import CustomNumberFormatNoSeparator from '../components/custom_number_format_noseparator'
import CloseIcon from '@material-ui/icons/Close'
import DialogActions from '@material-ui/core/DialogActions'
import CreditRequest from './CreditRequest'
import CreateCreditRequest from './create_credit_request'
import Slide from '@material-ui/core/Slide'
import LinearProgress from '@material-ui/core/LinearProgress'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'

let timer = null

class CreditRequests extends Component {
  constructor(props) {
    super(props)

    this.state = {
      creditRequests: [],
      seoNumber: '',
      token: localStorage.getItem('token'),
      isLoading: false,
      isSendLoading: false,
      filterAllRequests: 0,
      currentPage: 0,
      rowsPerPage: 10,
      clientIIN: '',
      filterStartDate: moment(new Date()).subtract(1, 'week').toDate(),
      filterEndDate: new Date(),
      isEurasianDialogOpen: false,
      eurasianBankProductCode: '',
      selectedCreditRequest: null,
      currentProducts: [],
      managers: [],
      selectedProduct: '',
      selectedBank: '',
      snackbarOpen: false,
      isRefreshIconDisabled: false,
      selectedBranch: '',
      isSendingToEurasianBank: false,
      selectedStatus: 'all',
      roleCode: '',
      username: '',
      filterBank: '',
      purpose: '',
      requestid: '',
      rl_id: '',

      branches: [],
      error: false
    }
    console.log('credit requests')
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
  }

  handleCloseSnackbar() {
    this.setState({
      snackbarOpen: false
    })
  }

  isAdmin() {
    let userRoles = parseJwt(this.state.token).roleList
    for (let role of userRoles) {
      if (role.code === 'ADMIN' && role.project.code === 'FB') {
        return true
      }
    }

    return false
  }

  isMix() {
    let userRoles = parseJwt(this.state.token).roleList
    for (let role of userRoles) {
      if (role.code === 'MANAGER_AMP_NEWCAR' || role.code === 'HEAD_FS') {
        return true
      }
    }

    return false
  }

  componentDidMount() {
    if (this.props.location.state !== undefined) {
      this.setState(
        { selectedStatus: this.props.location.state.selectedStatus },
        () => {
          this.getCreditRequests()
        }
      )
    } else {
      this.getCreditRequests()
    }
    this.getBranches()
    timer = setInterval(() => {
      this.getCreditRequests()
    }, 6000000)
  }

  componentWillUnmount() {
    clearInterval(timer)
  }

  getCreditRequests(offset = 0, limit = 10) {
    this.setState({ isLoading: true })
    let self = this
    axios
      .get(
        FB_API_URL +
          '/finbroker/credit_request/filter/?offset=' +
          offset +
          '&limit=' +
          limit +
          '&startDate=' +
          moment(this.state.filterStartDate).format('YYYY-MM-DD') +
          '&endDate=' +
          moment(this.state.filterEndDate).format('YYYY-MM-DD') +
          '&iin=' +
          this.state.clientIIN +
          '&username=' +
          this.state.username +
          '&status=' +
          this.state.selectedStatus +
          '&branchCode=' +
          this.state.selectedBranch +
          '&bankSend=' +
          this.state.filterBank +
          '&requestid=' +
          this.state.requestid +
          '&rl_id=' +
          this.state.rl_id +
          '&purpose=' +
          this.state.purpose,
        { headers: { Authorization: `Bearer ${this.state.token}` } }
      )
      .then(function (response) {
        console.log(response.data)
        self.setState({
          isLoading: false,
          isRefreshIconDisabled: false,
          creditRequests: response.data.creditRequests,
          filterAllRequests: response.data.creditRequestsFilterCount
        })
      })
      .catch(function (error) {
        self.setState({ isLoading: false, isRefreshIconDisabled: false })
        console.log(error.message)
        if (error.message.includes('403')) {
          self.props.history.push('/signin')
        }
      })
  }

  getManagers() {
    axios
      .post(
        AUTH_API_URL + '/users/getUsers',
        {
          branchCode: this.state.selectedBranch || '',
          isActive: true,
          isSystemUser: false,
          projectCode: 'FB',
          roleCode: this.state.roleCode || '',
          limit: 100
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem('token')}`
          }
        }
      )
      .then(response => {
        this.setState({
          managers: response.data.userList
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  sendToFinOrg(finOrgName, creditRequest) {
    if (
      creditRequest.agreementFileLocation === null ||
      creditRequest.agreementFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Согласие на обработку персональных данных'
      })
    } else if (
      creditRequest.idFrontFileLocation === null ||
      creditRequest.idFrontFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Удостоверение личности (лицевая сторона)'
      })
    } else if (
      creditRequest.idBackFileLocation === null ||
      creditRequest.idBackFileLocation === undefined
    ) {
      this.setState({
        error: 'Загрузите Удостоверение личности (обратная сторона)'
      })
    } else if (finOrgName === 'mogo') {
      if (window.confirm('Вы готовы отправить заявку в Mogo?')) {
        let self = this
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {},
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.getCreditRequests()
            self.props.enqueueSnackbar(
              'Кредитная заявка успешно отправлена в Mogo.',
              { variant: 'success' }
            )
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              error:
                'Кредитная заявка не отправлена в Mogo.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    } else if (finOrgName === 'eurasian') {
      if (window.confirm('Вы готовы отправить заявку в Евразийский Банк?')) {
        let self = this
        self.setState({ isSendingToEurasianBank: true })
        axios
          .post(
            FB_API_URL +
              `/finbroker/credit_request/send_to_fin_org/${finOrgName}/${creditRequest.id}`,
            {
              eurasianBankProductCode: '0',
              eurasianBankProductRate: '0'
            },
            { headers: { Authorization: `Bearer ${this.state.token}` } }
          )
          .then(function (response) {
            console.log(response)
            self.setState({
              isSendingToEurasianBank: false,
              isEurasianDialogOpen: false
            })
            self.getCreditRequests()
            self.setState({
              error: 'Кредитная заявка успешно отправлена в Евразийский Банк.'
            })
          })
          .catch(function (error) {
            console.log(error.response)
            self.setState({
              isSendingToEurasianBank: false,
              isEurasianDialogOpen: false,
              error:
                'Кредитная заявка не отправлена в Евразийский Банк.\n\nОшибка: ' +
                error.response.request.responseText
            })
          })
      }
    }
  }

  deleteCreditRequest(creditRequestId) {
    if (window.confirm('Вы готовы удалить кредитную заявку?')) {
      let self = this
      axios
        .post(
          FB_API_URL + `/finbroker/credit_request/delete/${creditRequestId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.state.token}`
            }
          }
        )
        .then(function () {
          self.getCreditRequests()
        })
        .catch(function (error) {
          console.log(error.message)
        })
    }
  }

  handleCapture(creditRequestId, type, event) {
    console.log(event)
    let self = this
    const formData = new FormData()
    let file = event.target.files[0]
    formData.append('file', file)
    axios
      .post(
        FB_API_URL +
          '/finbroker/credit_request/uploadFile/' +
          type +
          '/' +
          creditRequestId,
        formData,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then(function (response) {
        console.log(response)
        self.getCreditRequests()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  handleChangePage(event, newPage) {
    this.setState(
      {
        currentPage: newPage
      },
      () => {
        let offset = newPage * this.state.rowsPerPage
        let limit = this.state.rowsPerPage
        this.getCreditRequests(offset, limit)
      }
    )
  }

  handleChangeRowsPerPage(event) {
    this.setState(
      {
        currentPage: 0,
        rowsPerPage: parseInt(event.target.value, 10)
      },
      () => {
        this.getCreditRequests(0, this.state.rowsPerPage)
      }
    )
  }

  handleChange = name => event => {
    this.setState(
      {
        [name]: event.target.value
      },
      () => {
        if (name === 'selectedBranch' || name === 'roleCode') {
          this.getManagers()
        }
      }
    )
  }

  handleChangeDate = name => date => {
    this.setState({
      [name]: date
    })
  }

  handleSearch() {
    this.setState(
      {
        currentPage: 0
      },
      () => {
        if (this.state.filterStartDate > this.state.filterEndDate) {
          this.setState({
            error: 'Дата начала не может быть после даты конца'
          })
        } else {
          this.getCreditRequests(0, this.state.rowsPerPage)
        }
      }
    )
  }

  handleResetFilter() {
    this.setState(
      {
        currentPage: 0,
        filterStartDate: moment(new Date()).subtract(1, 'months').toDate(),
        filterEndDate: moment(new Date()).toDate(),
        clientIIN: '',
        selectedBranch: '',
        filterBank: '',
        roleCode: '',
        username: ''
      },
      () => {
        this.getCreditRequests(0, this.state.rowsPerPage)
      }
    )
  }

  clearFile(creditRequestId, type) {
    if (window.confirm('Вы готовы удалить файл?')) {
      let self = this
      axios
        .post(
          FB_API_URL +
            '/finbroker/credit_request/clearFile/' +
            type +
            '/' +
            creditRequestId,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.state.token}`
            }
          }
        )
        .then(function (response) {
          console.log(response)
          self.getCreditRequests(self.state.currentPage, self.state.rowsPerPage)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    }
  }

  downloadFile(creditRequestId, type) {
    axios
      .get(
        FB_API_URL +
          '/finbroker/credit_request/downloadFile/' +
          type +
          '/' +
          creditRequestId,
        {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${this.state.token}`
          }
        }
      )
      .then(function (response) {
        console.log(response)
        let fileName = response.headers.pragma
        let fileExtension = fileName.split('.').pop()
        let blob = new Blob([response.data], {
          type: 'application/' + fileExtension
        })
        const downloadUrl = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  getBranches() {
    axios
      .get(AUTH_API_URL + '/branches', {
        headers: {
          Authorization: `Bearer ${this.state.token}`
        }
      })
      .then(response => {
        this.setState({
          branches: response.data
        })
        console.log(this.state.branches, 'test')
      })
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center' }}>
          <div>
            <div style={{ textAlign: 'left', margin: 'auto' }}>
              {/*<SeoQueueBlock />*/}
              <div className="btn-calc" style={{ marginBottom: '10px' }}>
                <Button
                  className="button_small button_grey_color"
                  variant="contained"
                  color="primary"
                  style={{ marginRight: '10px' }}
                  onClick={() => this.props.history.push('/')}
                >
                  Назад
                </Button>
                <span style={{ fontSize: '22px', fontWeight: 'bold' }}>
                  Кредитные заявки
                </span>
              </div>

              <Paper className="filter">
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <div
                    style={{
                      marginTop: '13.5px',
                      width: '125px',
                      marginRight: '5px'
                    }}
                  >
                    <TextField
                      label="ИИН"
                      value={this.state.clientIIN}
                      onChange={this.handleChange('clientIIN')}
                      InputProps={{
                        inputComponent: CustomNumberFormatNoSeparator,
                        className: 'textfield_green'
                      }}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: '13.5px',
                      width: '125px',
                      marginRight: '5px'
                    }}
                  >
                    <TextField
                      label="# Заявки"
                      value={this.state.requestid}
                      onChange={this.handleChange('requestid')}
                      InputProps={{
                        inputComponent: CustomNumberFormatNoSeparator,
                        className: 'textfield_green'
                      }}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: '13.5px',
                      width: '125px',
                      marginRight: '5px'
                    }}
                  >
                    <TextField
                      label="# РЛ"
                      value={this.state.rl_id}
                      onChange={this.handleChange('rl_id')}
                      InputProps={{
                        inputComponent: CustomNumberFormatNoSeparator,
                        className: 'textfield_green'
                      }}
                    />
                  </div>
                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel htmlFor="status">
                        Цель кредитования
                      </InputLabel>
                      <Select
                        className="textfield_green"
                        value={this.state.purpose}
                        onChange={this.handleChange('purpose')}
                      >
                        <MenuItem value={'Приобретение БУ авто'}>
                          Приобретение БУ авто
                        </MenuItem>
                        <MenuItem value={'Приобретение нового авто'}>
                          Приобретение нового авто
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ width: '136px', marginRight: '5px' }}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      variant="outlined"
                    >
                      <KeyboardDatePicker
                        margin="normal"
                        label="Дата начала"
                        format="dd.MM.yyyy"
                        value={this.state.filterStartDate}
                        onChange={this.handleChangeDate('filterStartDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div style={{ width: '136px', marginRight: '10px' }}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      variant="outlined"
                    >
                      <KeyboardDatePicker
                        margin="normal"
                        label="Дата конца"
                        format="dd.MM.yyyy"
                        value={this.state.filterEndDate}
                        onChange={this.handleChangeDate('filterEndDate')}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>

                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel htmlFor="city">Город</InputLabel>
                      <Select
                        className="textfield_green"
                        value={this.state.selectedBranch}
                        onChange={this.handleChange('selectedBranch')}
                      >
                        {this.state.branches &&
                          this.state.branches.map(val => (
                            <MenuItem value={val.code}>{val.name}</MenuItem>
                          ))}
                        {/*
                          <MenuItem value={'ALA_SUYUNBAI'}>
                            Алматы (Суюнбая)
                          </MenuItem>
                          <MenuItem value={'ASTANA'}>Астана</MenuItem>
                          <MenuItem value={'ASTANA_GS'}>
                            Астана (Gold Star)
                          </MenuItem>
                          <MenuItem value={'ASTANA_METRO'}>
                            Астана Метро
                          </MenuItem>
                          <MenuItem value={'SHYMKENT'}>Шымкент</MenuItem>
                          <MenuItem value={'KOSTANAY'}>Костанай</MenuItem>
                          <MenuItem value={'KARAGANDA'}>Караганда</MenuItem>
                          <MenuItem value={'PAVLODAR'}>Павлодар</MenuItem>
                          <MenuItem value={'OSKEMEN'}>Усть-Каменогорск</MenuItem>
                          <MenuItem value={'AKTAU'}>Актау</MenuItem>
                          <MenuItem value={'AKTOBE'}>Актобе</MenuItem>
                          <MenuItem value={'ATYRAU'}>Атырау</MenuItem>
                          <MenuItem value={'KORDA'}>Кызылорда</MenuItem>
                          <MenuItem value={'KOKSHETAU'}>Кокшетау</MenuItem>
                          <MenuItem value={'PETROPAVL'}>Петропавловск</MenuItem>
                          <MenuItem value={'EKIBASTUZ'}>Екибастуз</MenuItem>
                          <MenuItem value={'SARYAGASH'}>Сарыагаш</MenuItem>
                          <MenuItem value={'SEMEY'}>Семей</MenuItem>
                          <MenuItem value={'URALSK'}>Уральск</MenuItem>
                          <MenuItem value={'TARAZ'}>Тараз</MenuItem>
                           */}
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel htmlFor="status">Статус</InputLabel>
                      <Select
                        className="textfield_green"
                        value={this.state.selectedStatus}
                        onChange={this.handleChange('selectedStatus')}
                      >
                        <MenuItem value={'all'}>Все</MenuItem>
                        <MenuItem value={'approved'}>Одобрено</MenuItem>
                        <MenuItem value={'rejected'}>Отказано</MenuItem>
                        <MenuItem value={'unanswered'}>Без ответа</MenuItem>
                        <MenuItem value={'unsent'}>Не отправленные</MenuItem>
                        <MenuItem value={'alternative'}>Альтернатива</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel>Банк</InputLabel>
                      <Select
                        value={this.state.filterBank}
                        onChange={this.handleChange('filterBank')}
                      >
                        <MenuItem value={''}>Не выбрано</MenuItem>
                        <MenuItem value={'KMF'}>КМФ</MenuItem>
                        <MenuItem value={'SHINHAN'}>Шинхан Банк</MenuItem>
                        <MenuItem value={'MOGO'}>Мого</MenuItem>
                        <MenuItem value={'EURAZ'}>Евразийский Банк</MenuItem>
                        <MenuItem value={'BCC'}>БЦК </MenuItem>
                        <MenuItem value={'HALYK'}>Халык</MenuItem>
                        <MenuItem value={'BEREKE'}>Bereke</MenuItem>
                        <MenuItem value={'FREEDOM'}>Freedom</MenuItem>
                        <MenuItem value={'FORTE'}>Forte</MenuItem>
                        <MenuItem value={'TFS'}>Toyota Finance</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel>Роль</InputLabel>
                      <Select
                        value={this.state.roleCode}
                        onChange={this.handleChange('roleCode')}
                      >
                        <MenuItem value="">Не выбрано</MenuItem>
                        <MenuItem value="MANAGER_NEWCAR">Менеджер ОПА</MenuItem>
                        <MenuItem value="ADMIN">Менеджер АМП</MenuItem>
                        <MenuItem value="MANAGER_AMP_NEWCAR">
                          Менеджер АМП+ОПА
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ marginTop: '14px', marginRight: '10px' }}>
                    <FormControl style={{ minWidth: '150px' }}>
                      <InputLabel>Менеджер</InputLabel>
                      <Select
                        value={this.state.username}
                        onChange={this.handleChange('username')}
                      >
                        <MenuItem value="">Не выбрано</MenuItem>
                        {this.state.managers.map((item, i) => (
                          <MenuItem value={item.username}>
                            {item.firstName} {item.lastName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div style={{ marginTop: '20px', marginRight: '10px' }}>
                    <Button
                      className="button_small button_green_color"
                      style={{ marginTop: '10px', paddingLeft: '10px' }}
                      color="primary"
                      variant="contained"
                      onClick={this.handleSearch.bind(this)}
                    >
                      <SearchIcon
                        style={{ fontSize: '18px', marginRight: '5px' }}
                      />
                    </Button>
                  </div>
                  <div style={{ marginTop: '20px' }}>
                    <Button
                      className="button_small button_grey_color"
                      style={{
                        marginTop: '10px',
                        paddingLeft: '10px',
                        backgroundColor: '#ff5733 ',
                        color: '#FFF'
                      }}
                      onClick={this.handleResetFilter.bind(this)}
                      variant="contained"
                    >
                      <ClearIcon style={{ fontSize: '18px' }} />
                    </Button>
                  </div>
                  {/*{this.isMix() && (*/}
                  {/*  <>*/}
                  {/*    <div style={{ marginTop: '20px' }}>*/}
                  {/*      <Button*/}
                  {/*        className="button_green_color button_small"*/}
                  {/*        style={{*/}
                  {/*          marginTop: '10px',*/}
                  {/*          marginLeft: '10px',*/}
                  {/*          paddingLeft: '10px'*/}
                  {/*        }}*/}
                  {/*        onClick={() => {*/}
                  {/*          axios*/}
                  {/*            .get(*/}
                  {/*              FB_API_URL +*/}
                  {/*                '/finbroker/credit_request/getUndecidedCreditRequests',*/}
                  {/*              {*/}
                  {/*                headers: {*/}
                  {/*                  Authorization: `Bearer ${localStorage.getItem(*/}
                  {/*                    'token'*/}
                  {/*                  )}`*/}
                  {/*                }*/}
                  {/*              }*/}
                  {/*            )*/}
                  {/*            .then(response => {*/}
                  {/*              if (response.data.length > 0) {*/}
                  {/*                alert(*/}
                  {/*                  'У вас имеются заявки без ответа, обработайте их сначала!'*/}
                  {/*                )*/}
                  {/*              } else {*/}
                  {/*                this.setState({*/}
                  {/*                  isNewCreditRequestDialogOpen: true*/}
                  {/*                })*/}
                  {/*              }*/}
                  {/*            })*/}
                  {/*            .catch(error => {*/}
                  {/*              console.log(error.message)*/}
                  {/*            })*/}
                  {/*        }}*/}
                  {/*      >*/}
                  {/*        Новая кредитная заявка*/}
                  {/*      </Button>*/}
                  {/*    </div>*/}
                  {/*  </>*/}
                  {/*)}*/}
                </div>
              </Paper>

              {this.state.isLoading && <LinearProgress />}

              <Table>
                <TableHead>
                  <TableRow>
                    <TablePagination
                      style={{ fontSize: '16px' }}
                      rowsPerPageOptions={[10, 50, 100]}
                      colSpan={14}
                      count={this.state.filterAllRequests}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.currentPage}
                      labelRowsPerPage={''}
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} из ${count}`
                      }
                      SelectProps={{
                        inputProps: { 'aria-label': 'Кол' },
                        native: true
                      }}
                      onChangePage={this.handleChangePage.bind(this)}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(
                        this
                      )}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.creditRequests.length === 0 && (
                    <TableRow>
                      <TableCell
                        style={{ borderBottom: 'none', padding: '0px' }}
                      >
                        <span style={{ fontSize: '18px' }}>Нет данных</span>
                      </TableCell>
                    </TableRow>
                  )}

                  {this.state.creditRequests.map(creditRequest => (
                    <TableRow key={creditRequest.id}>
                      <TableCell
                        style={{ borderBottom: 'none', padding: '0px' }}
                      >
                        <CreditRequest
                          key={creditRequest.id}
                          onClick={() =>
                            this.setState({
                              selectedCreditRequestForView: creditRequest
                            })
                          }
                          getCreditRequests={this.getCreditRequests.bind(this)}
                          creditRequest={creditRequest}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter align="left" style={{ align: 'left' }}>
                  <TableRow align="left" style={{ align: 'left' }}>
                    <TablePagination
                      rowsPerPageOptions={[10, 50, 100]}
                      colSpan={14}
                      count={this.state.filterAllRequests}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.currentPage}
                      labelRowsPerPage={''}
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} из ${count}`
                      }
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'Кол-во строк на странице'
                        },
                        native: true
                      }}
                      onChangePage={this.handleChangePage.bind(this)}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(
                        this
                      )}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </div>
        </div>

        <Dialog
          onClose={() => {
            this.setState({ isEurasianDialogOpen: false })
          }}
          open={this.state.isEurasianDialogOpen}
          keepMounted
        >
          <DialogTitle>Отправка в Евразийский Банк</DialogTitle>
          <DialogContent>
            <div className="btn-dialog">
              <Button
                disabled={this.state.isSendingToEurasianBank}
                className="button_small button_green_color"
                onClick={this.sendToFinOrg.bind(
                  this,
                  'eurasian',
                  this.state.selectedCreditRequest
                )}
              >
                Отправить
              </Button>
              <Button
                className="button_small button_grey_color"
                onClick={() => this.setState({ isEurasianDialogOpen: false })}
              >
                Закрыть
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={this.state.snackbarOpen}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
          message="Заявка обновлена"
          action={
            <React.Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        />

        {this.state.isNewCreditRequestDialogOpen && (
          <Dialog
            open={this.state.isNewCreditRequestDialogOpen}
            fullScreen
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({ isNewCreditRequestDialogOpen: false })
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">Кредитная заявка</Typography>
              </Toolbar>
            </AppBar>
            <div style={{ marginTop: '80px' }}>
              <CreateCreditRequest
                closeDialog={() => {
                  this.setState({ isNewCreditRequestDialogOpen: false })
                }}
                sale={this.props.sale}
              />
            </div>
          </Dialog>
        )}
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})

export default flowRight(withSnackbar)(CreditRequests)
